function ProfileUser(profile) {
    let profileUser = profile || {};
    this.id = profileUser.id;
    this.email = profileUser.email;
    this.firstName = profileUser.firstName;
    this.lastName = profileUser.lastName;
    this.verified = profileUser.verified;
    this.role = profileUser.role;
    this.active = profileUser.active;
}

module.exports = ProfileUser;